import { useState } from "react";
import { toast } from "react-hot-toast";
import { adminApi, apiErrorMessage } from "../../api/adminApi";
import { usePermissions } from "../../permissions/usePermissions";
import "../../main.scss";

export default function Account() {
  const { user: me } = usePermissions();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error("كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("تأكيد كلمة المرور غير متطابق");
      return;
    }
    setSaving(true);
    try {
      const res = await adminApi.changeMyPassword(currentPassword, newPassword);
      toast.success(res.message || "تم تغيير كلمة المرور بنجاح");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      toast.error(apiErrorMessage(err, "فشل تغيير كلمة المرور"));
    }
    setSaving(false);
  };

  return (
    <div className="page account-page">
      <div className="page__header">
        <div>
          <h1 className="page__title">حسابي</h1>
          <p className="page__sub">
            {me?.fullName || me?.username || ""} — {me?.roleName || ""}
          </p>
        </div>
      </div>

      <div className="form-card">
        <h3>تغيير كلمة المرور</h3>
        <form onSubmit={handleSubmit}>
          <label>
            كلمة المرور الحالية
            <input
              type="password"
              dir="ltr"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
          <label>
            كلمة المرور الجديدة
            <input
              type="password"
              dir="ltr"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="6 أحرف على الأقل"
              required
              autoComplete="new-password"
            />
          </label>
          <label>
            تأكيد كلمة المرور الجديدة
            <input
              type="password"
              dir="ltr"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </label>
          <div className="form-actions">
            <button
              type="submit"
              className="btn btn--primary"
              disabled={saving}
            >
              {saving ? "جاري الحفظ..." : "حفظ كلمة المرور"}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .account-page { padding: 20px; max-width: 640px; margin: 0 auto; }
        .page__header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }
        .page__title { margin: 0 0 4px; font-size: 22px; color: var(--text); }
        .page__sub { margin: 0; color: var(--text-muted); font-size: 13px; }
        .form-card { background: var(--card); border: 1px solid var(--border); border-radius: 6px; padding: 22px; }
        .form-card h3 { margin: 0 0 16px; color: var(--text); font-size: 17px; }
        .form-card label { display: block; margin-bottom: 14px; color: var(--text); font-size: 14px; }
        .form-card input { display: block; width: 100%; margin-top: 6px; padding: 10px 12px; border: 1px solid var(--border); border-radius: 6px; background: var(--bg); color: var(--text); font-size: 15px; box-sizing: border-box; }
        .form-card input:focus { outline: none; border-color: var(--accent); }
        .form-actions { margin-top: 18px; }
      `}</style>
    </div>
  );
}
